import NotificationsModal from './notifications-modal';
import Modal from 'react-modal';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NotificationsView from '../../classes/notifications';

function Notifications(props) {
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [SelectedMessageId, setSelectedMessageId] = useState(null);
  const [NotificationsQty, setNotificationsQty] = useState(6);

  useEffect(() => {
    if (props.isMobile) {
      setNotificationsQty(3);
    } else {
      setNotificationsQty(6);
    }
  }, [props.isMobile]);

  useEffect(() => {
    if (!ModalIsOpen && props.getNotifications) {
      props.getNotifications();
    }
  }, [ModalIsOpen]);

  const readNotification = async (id) => {
    let _notifications = new NotificationsView();
    let _res = await _notifications.read1Notification(id);
    if (_res) {
      //   console.log(_res)
      // props.getNotifications();
    }
  };

  function closeModal() {
    setModalIsOpen(false);
  }

  function openModal(e) {
    //   alert('a')
    setModalIsOpen(true);
    setSelectedMessageId(e.currentTarget.id);
  }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      backgroundColor: 'none',
      background: 'none',
      zIndex: '1200',
    },
  };

  const NotificationsTable = () => {
    if (props.NotificationsMsg) {
      return props.NotificationsMsg.slice(0, NotificationsQty).map((data, i) => {
        // console.log(data)
        return (
          <tr
            id={i}
            onClick={(e) => {
              openModal(e);
            }}
          >
            <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
              <i className={data.bms_leido ? 'icon-mail' : 'icon-mail blue'} style={{ fontSize: '20px' }}></i>
            </th>
            <th>
              <div style={{ fontWeight: 'normal' }}>{data.bms_fecha_hora}</div>
              {data.bms_clave_seguim}
            </th>
            <th>
              <div style={{ fontWeight: 'normal' }}>{data.bms_autor}</div>
              {data.bms_asunto}
            </th>
          </tr>
        );
      });
    }
  };

  const NotificationsTable2 = () => {
    if (props.NotificationsMsg) {
      return props.NotificationsMsg.slice(0, 6).map((data, i) => {
        // console.log(data)
        return (
          <tr
            id={i}
            onClick={(e) => {
              openModal(e);
            }}
          >
            <th
              style={{ textAlign: 'center', verticalAlign: 'middle' }}
              className={props.isMobile ? 'hidden' : null}
            >
              <i className={data.bms_leido ? 'icon-mail' : 'icon-mail blue'} style={{ fontSize: '20px' }}></i>
            </th>
            <th>
              {props.isMobile ? (
                <i
                  className={data.bms_leido ? 'icon-mail' : 'icon-mail blue'}
                  style={{ fontSize: '7px' }}
                ></i>
              ) : null}
              <div className="row">
                <div className="col-sm-6 grey notifications-date">{data.bms_fecha_hora}</div>
                {props.isMobile ? null : (
                  <div className="col-sm-6 grey notifications-email">{data.bms_autor}</div>
                )}
              </div>
              <div className="row">
                <div className="col-sm-12 notifications-subject">{data.bms_asunto}</div>
              </div>
              <div className="row">
                <div className="col-sm-6 notifications-key">{data.bms_clave_seguim}</div>
              </div>
            </th>
          </tr>
        );
      });
    }
  };

  const notificationsUlClassname = () => {
    if (!props.NotificationsMsg || (props.NotificationsMsg && props.NotificationsMsg.length < 1)) {
      return 'hidden';
    } else if (props.isMobile) {
      return 'toolbar-dropdown lang-dropdown w-100';
    } else {
      return 'toolbar-dropdown lang-dropdown notifications-table';
    }
  };

  return (
    <ul className={notificationsUlClassname()}>
      <div className={props.NotificationsMsg && props.NotificationsMsg.length > 0 ? '' : 'hidden'}>
        <table className=" table table-hover">
          <tbody>{NotificationsTable2()}</tbody>
        </table>
        <div style={{ textAlign: 'center' }}>
          {/* <Link to="/Notificaciones">
            <button
              className="btn btn-primary btn-sm"
              type="button"
              onClick={() => {
                // props.closeModal();
              }}
              style={{ width: '40%' }}
            >
              &nbsp; Ver todos
            </button>
          </Link> */}
        </div>
        <div style={{ textAlign: 'center' }}>
          <Link to="/NotificacionesList">
            <button
              className="btn btn-primary btn-sm"
              type="button"
              onClick={() => {
                // props.closeModal();
              }}
              style={{ minWidth: '40%' }}
            >
              &nbsp; Ver lista
            </button>
          </Link>
        </div>
      </div>
      {/* <NotificationsModal /> */}
      <Modal
        isOpen={ModalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        style={customStyles}
      >
        <NotificationsModal
          closeModal={closeModal}
          NotificationsMsg={props.NotificationsMsg}
          SelectedMsgIndex={SelectedMessageId}
        />
      </Modal>
    </ul>
  );
}

export default Notifications;
